import type { Tab } from "types/tabs.types"

import { ALL_ALERTS_SEARCH_PARAMS } from "./constants"

export const getPowerlineTabsConfig = (search: string): Tab[] => [
  {
    labelKey: "tabs.OVERVIEW",
    value: 0,
    to: { pathname: "", search },
  },
  {
    labelKey: "tabs.ASSETS",
    value: 1,
    to: { pathname: "assets" },
  },
  {
    labelKey: "tabs.ALERTS",
    value: 2,
    to: { pathname: "alerts", search: ALL_ALERTS_SEARCH_PARAMS },
  },
  {
    labelKey: "tabs.SETTINGS",
    value: 3,
    to: { pathname: "settings" },
  },
]
